import * as B from "../../battle.mjs";
import { floatText, shake, banner, bindBounce } from "../juice.js";
import * as sfx from "../audio.js";

const $ = (id) => document.getElementById(id);
const cv = $("board"), g = cv.getContext("2d");
const qs = new URLSearchParams(location.search);
let baseSig = "", battle, ai, last = 0, paused = false, selected = null, mode = null, fx = [], harv = [], dragging = null;
const ORDER_UI = { push: { t: "PUSH", i: "⏩", c: "#3ddc84" }, hold: { t: "HOLD", i: "✋", c: "#7ec8e3" }, focus: { t: "FOCUS", i: "🎯", c: "#ffa12e" } };
const COL = { 0: { main: "#3aa0ff", dark: "#1b4f8a", glow: "#9fd4ff" }, 1: { main: "#ff4d4d", dark: "#8a1b1b", glow: "#ffb0b0" } };

// ---------- layout ----------
let sx = 40, sy = 40, dpr = 1;
function resize() {
  dpr = Math.min(devicePixelRatio || 1, 2);
  const r = cv.getBoundingClientRect();
  cv.width = r.width * dpr; cv.height = r.height * dpr;
  sx = r.width / B.W; sy = r.height / B.H;
  layoutLaneChips();
}
const px = (x) => x * sx, py = (y) => y * sy;
const toWorld = (e) => { const r = cv.getBoundingClientRect(); return { x: (e.clientX - r.left) / sx, y: (e.clientY - r.top) / sy }; };
const toScreen = (x, y) => { const r = cv.getBoundingClientRect(); return { x: r.left + px(x), y: r.top + py(y) }; };

// ---------- setup ----------
function newMatch() {
  battle = B.createBattle((Math.random() * 1e9) | 0);
  ai = B.createAI(1);
  fx = []; selected = null; mode = null;
  harv = [];
  $("end").hidden = true;
  buildTray(); buildLaneChips(); syncHud();
  banner("DEPLOY!", "you");
}

function buildTray() {
  const tray = $("tray"); tray.innerHTML = "";
  for (const [k, u] of Object.entries(B.UNITS)) {
    const c = document.createElement("button");
    c.className = "deck-card"; c.dataset.type = k;
    c.innerHTML = `<span class="ico">${u.icon}</span><span class="nm">${u.name}${u.count > 1 ? ` ×${u.count}` : ""}</span><span class="cost">◆${u.cost}</span><span class="lock">🔒 ${u.needs === "factory" ? "Factory" : "Tech Lab"}</span><i class="fill"></i>`;
    c.addEventListener("pointerdown", (e) => startDrag(e, k));
    tray.appendChild(c);
  }
}

function buildLaneChips() {
  const box = $("lane-orders"); box.innerHTML = "";
  B.LANES.forEach((_, i) => {
    const b = document.createElement("button");
    b.className = "lane-chip"; b.dataset.lane = i;
    b.addEventListener("click", (e) => { e.stopPropagation(); cycleOrder(i); });
    box.appendChild(b);
  });
  layoutLaneChips();
}
function layoutLaneChips() {
  const r = cv.getBoundingClientRect();
  document.querySelectorAll(".lane-chip").forEach((b, i) => {
    b.style.left = `${r.left + px(B.LANES[i])}px`; b.style.top = `${r.top + py(B.MID + 2.2)}px`;
  });
}
function cycleOrder(lane) {
  const cur = battle.sides[0].orders[lane];
  const next = B.ORDERS[(B.ORDERS.indexOf(cur) + 1) % 3];
  B.setOrder(battle, 0, lane, next); sfx.ui();
  const p = toScreen(B.LANES[lane], B.MID + 1.2);
  floatText(p.x, p.y, `${ORDER_UI[next].i} ${ORDER_UI[next].t}`, "order");
  fx.push({ k: "lanePulse", lane, t: 0.6, c: ORDER_UI[next].c });
  syncHud();
}

// ---------- input ----------
function startDrag(e, type) {
  sfx.resume();
  if (!B.canDeploy(battle, 0, type)) { sfx.ui(); const c = e.currentTarget; c.classList.remove("nope"); void c.offsetWidth; c.classList.add("nope"); return; }
  selected = selected === type ? null : type; mode = selected ? "deploy" : null;
  dragging = { type, x0: e.clientX, y0: e.clientY, moved: false };
  syncHud();
}
addEventListener("pointermove", (e) => {
  if (!dragging) return;
  if (Math.hypot(e.clientX - dragging.x0, e.clientY - dragging.y0) > 12) { dragging.moved = true; selected = dragging.type; mode = "deploy"; }
  dragging.at = toWorld(e);
});
addEventListener("pointerup", (e) => {
  if (!dragging) return;
  const d = dragging; dragging = null;
  if (d.moved) { const w = toWorld(e); if (w.y >= 0 && w.y <= B.H) tryDeploy(w); }
});
cv.addEventListener("pointerdown", (e) => {
  sfx.resume();
  const w = toWorld(e);
  if (mode === "strike") {
    if (B.airstrike(battle, 0, w.x, w.y)) { sfx.ui(); banner("AIRSTRIKE INBOUND", "you"); }
    mode = null; syncHud(); return;
  }
  if (mode === "deploy" && selected) { tryDeploy(w); return; }
  // Tap a squad (or its lane) to cycle that lane's order.
  const near = battle.units.find((u) => u.owner === 0 && Math.hypot(u.x - w.x, u.y - w.y) < 0.7);
  cycleOrder(near ? near.lane : B.nearestLane(w.x));
});
function tryDeploy(w) {
  const type = selected;
  if (!B.ownHalf(0, w.y)) { const p = toScreen(w.x, w.y); floatText(p.x, p.y, "Your side only", "warn"); return; }
  const lane = B.nearestLane(w.x);
  if (B.deploy(battle, 0, type, lane, w.y)) {
    sfx.move();
    fx.push({ k: "ring", x: B.LANES[lane], y: w.y, t: 0.5, c: COL[0].glow });
    if (!B.canDeploy(battle, 0, type)) { selected = null; mode = null; }
  }
  syncHud();
}
$("btn-strike").addEventListener("click", () => {
  if (battle.sides[0].strikeCd > 0) return;
  mode = mode === "strike" ? null : "strike"; selected = null; sfx.ui(); syncHud();
  if (mode) banner("TAP A TARGET", "you");
});
$("btn-base").addEventListener("click", () => { renderBase(); $("base-sheet").hidden = false; sfx.ui(); });
$("base-close").addEventListener("click", () => { $("base-sheet").hidden = true; });
$("btn-menu").addEventListener("click", () => { sfx.ui(); paused = true; $("menu-sheet").hidden = false; });
const closeMenu = () => { $("menu-sheet").hidden = true; if ($("tip").hidden) paused = false; last = performance.now(); };
$("menu-close").addEventListener("click", closeMenu);
$("menu-restart").addEventListener("click", () => { closeMenu(); newMatch(); });
$("menu-tips").addEventListener("click", () => { $("menu-sheet").hidden = true; localStorage.removeItem("ic-auto-tut"); tutorial(); });
$("btn-restart").addEventListener("click", () => { sfx.ui(); newMatch(); });

function renderBase() {
  const s = battle.sides[0];
  const rows = [
    { key: "harv", icon: "🚜", name: `Harvester (${s.harvesters}/${B.HARVESTER.max})`, desc: `+${B.HARVESTER.rate}◆/s each, gathers on its own`, cost: B.HARVESTER.cost,
      done: s.harvesters >= B.HARVESTER.max, ok: s.credits >= B.HARVESTER.cost, act: () => B.buyHarvester(battle, 0) },
    { key: "barracks", icon: "🏠", name: "Barracks", desc: "Rifles + Rockets", done: true },
    ...Object.entries(B.BUILDINGS).map(([k, d]) => ({ key: k, icon: d.icon, name: d.name, desc: `Unlocks ${d.unlocks}`, cost: d.cost, done: s.built[k],
      need: !s.built[d.needs] ? `Needs ${B.BUILDINGS[d.needs]?.name || "Barracks"}` : null, ok: s.credits >= d.cost, act: () => B.build(battle, 0, k) })),
  ];
  const list = $("base-list"); list.innerHTML = "";
  for (const r of rows) {
    const el = document.createElement("div"); el.className = `base-row${r.done ? " done" : ""}`;
    el.innerHTML = `<span class="ico">${r.icon}</span><div class="txt"><b>${r.name}</b><small>${r.desc}</small></div>`;
    const b = document.createElement("button"); b.className = "big buy";
    if (r.done) { b.textContent = "✓ Built"; b.disabled = true; }
    else if (r.need) { b.textContent = r.need; b.disabled = true; }
    else { b.textContent = `◆${r.cost}`; b.disabled = !r.ok; b.onclick = () => { if (r.act()) { sfx.win(); renderBase(); syncHud(); } }; }
    if (r.key === "harv" && r.done) b.textContent = "Max";
    el.appendChild(b); list.appendChild(el);
  }
}

// ---------- tutorial: 3 tips max ----------
const TIPS = [
  "Drag a card onto <b>your half</b>. Troops march, pick targets and fight on their own.",
  "You're the general: tap a <b>lane chip</b> or a squad to switch <b>Push · Hold · Focus</b>.",
  "Open <b>🏗️ Base</b> for harvesters, Tanks and Artillery. Drop <b>✈️ Strike</b> on enemy clumps.",
];
function tutorial() {
  if (qs.has("notut") || localStorage.getItem("ic-auto-tut") === "1") return;
  let i = 0; paused = true;
  const show = () => { $("tip-text").innerHTML = TIPS[i]; $("tip-n").textContent = `${i + 1} / ${TIPS.length}`; $("tip").hidden = false; };
  $("tip-next").onclick = () => { sfx.ui(); i++; if (i >= TIPS.length) { $("tip").hidden = true; paused = false; localStorage.setItem("ic-auto-tut", "1"); last = performance.now(); } else show(); };
  show();
}

// ---------- HUD ----------
function syncHud() {
  const s = battle.sides[0];
  $("credits").textContent = Math.floor(s.credits);
  $("income").textContent = `+${B.income(s).toFixed(1)}/s`;
  $("hq0").style.width = `${(s.hq / B.HQ_HP) * 100}%`;
  $("hq1").style.width = `${(battle.sides[1].hq / B.HQ_HP) * 100}%`;
  const t = battle.t, m = Math.floor(t / 60), sec = Math.floor(t % 60);
  const clock = $("clock"); clock.textContent = t > B.OVERTIME ? `OVERTIME ${m}:${String(sec).padStart(2, "0")}` : `${m}:${String(sec).padStart(2, "0")}`;
  clock.classList.toggle("ot", t > B.OVERTIME);
  for (const c of document.querySelectorAll(".deck-card")) {
    const u = B.UNITS[c.dataset.type];
    c.classList.toggle("locked", !s.built[u.needs]);
    c.classList.toggle("poor", s.built[u.needs] && s.credits < u.cost);
    c.classList.toggle("sel", selected === c.dataset.type);
    c.querySelector(".fill").style.height = `${Math.min(1, s.credits / u.cost) * 100}%`;
  }
  const cd = s.strikeCd, max = B.strikeCooldown(s);
  const sb = $("btn-strike"); sb.classList.toggle("ready", cd <= 0); sb.classList.toggle("armed", mode === "strike");
  $("strike-cd").style.width = `${(1 - cd / max) * 100}%`;
  sb.querySelector("span").textContent = cd > 0 ? `✈️ ${Math.ceil(cd)}s` : "✈️ Strike";
  document.querySelectorAll(".lane-chip").forEach((b, i) => {
    const o = ORDER_UI[s.orders[i]]; b.innerHTML = `${o.i}<small>${o.t}</small>`; b.style.setProperty("--c", o.c);
  });
  const canBuy = s.credits >= B.HARVESTER.cost && s.harvesters < B.HARVESTER.max || Object.entries(B.BUILDINGS).some(([k, d]) => !s.built[k] && s.built[d.needs] && s.credits >= d.cost);
  $("btn-base").classList.toggle("glow", canBuy);
  document.body.classList.toggle("deploying", mode === "deploy");
  if (!$("base-sheet").hidden) {
    const sig = [s.harvesters, s.built.factory, s.built.techlab, s.credits >= B.HARVESTER.cost, s.credits >= B.BUILDINGS.factory.cost, s.credits >= B.BUILDINGS.techlab.cost].join();
    if (sig !== baseSig) { baseSig = sig; renderBase(); }
  }
}

// ---------- events → juice ----------
function handleEvents() {
  for (const e of B.drainEvents(battle)) {
    if (e.k === "shot") { fx.push({ k: "tracer", ...e, t: e.type === "artillery" ? 0.5 : 0.12, max: e.type === "artillery" ? 0.5 : 0.12 }); if (e.o === 0 || Math.random() < 0.5) sfx.weapon(e.type === "hq" ? "tank" : e.type); }
    else if (e.k === "hit") {
      const p = toScreen(e.x, e.y);
      if (e.hq) { floatText(p.x, p.y - 10, `-${e.amount}`, e.o === 0 ? "dmg" : "crit"); shake(e.o === 0 ? 0.8 : 0.4); fx.push({ k: "hqFlash", o: e.o, t: 0.2 }); }
      else if (e.amount >= 40) floatText(p.x, p.y - 8, `-${e.amount}`, "dmg");
    } else if (e.k === "ko") { fx.push({ k: "boom", x: e.x, y: e.y, t: 0.5, c: COL[e.o].main }); sfx.boom(); }
    else if (e.k === "strikeCall") fx.push({ k: "target", x: e.x, y: e.y, t: B.STRIKE.delay, o: e.o });
    else if (e.k === "strike") { fx.push({ k: "blast", x: e.x, y: e.y, t: 0.7 }); shake(1.4); sfx.boom(); sfx.hit(); }
    else if (e.k === "build" && e.o === 0) banner(`${B.BUILDINGS[e.key].name.toUpperCase()} ONLINE`, "you");
    else if (e.k === "build" && e.o === 1) banner(`ENEMY BUILT ${B.BUILDINGS[e.key].name.toUpperCase()}`, "ai");
    else if (e.k === "end") endScreen(e.winner);
  }
}
function endScreen(w) {
  const won = w === 0;
  $("end-icon").textContent = won ? "🏆" : "💀";
  $("end-title").textContent = won ? "VICTORY" : "DEFEAT";
  const m = Math.floor(battle.t / 60), s = Math.floor(battle.t % 60);
  $("end-sub").textContent = `${won ? "Enemy HQ destroyed" : "Your HQ fell"} in ${m}:${String(s).padStart(2, "0")}`;
  $("end").className = `end ${won ? "win" : "lose"}`; $("end").hidden = false;
  won ? sfx.win() : sfx.boom();
}

// ---------- draw ----------
function rr(x, y, w, h, r) { g.beginPath(); g.roundRect(x, y, w, h, r); }
function drawField() {
  const W = px(B.W), H = py(B.H);
  const grd = g.createLinearGradient(0, 0, 0, H);
  grd.addColorStop(0, "#5a3a3a"); grd.addColorStop(0.12, "#5f7a3c"); grd.addColorStop(0.5, "#6f8f45"); grd.addColorStop(0.88, "#5f7a3c"); grd.addColorStop(1, "#2f4a6a");
  g.fillStyle = grd; g.fillRect(0, 0, W, H);
  // checker grass
  g.fillStyle = "rgba(255,255,255,0.035)";
  for (let y = 0; y < B.H; y++) for (let x = 0; x < B.W; x++) if ((x + y) % 2) g.fillRect(px(x), py(y), sx, sy);
  // lanes (dirt roads)
  for (let i = 0; i < 3; i++) {
    const s = battle.sides[0].orders[i];
    g.fillStyle = "rgba(196,164,110,0.55)"; rr(px(B.LANES[i] - 0.55), py(1.8), sx * 1.1, py(B.H - 3.6), sx * 0.5); g.fill();
    g.strokeStyle = "rgba(90,60,30,0.35)"; g.lineWidth = 2; g.stroke();
    const pulse = fx.find((f) => f.k === "lanePulse" && f.lane === i);
    if (pulse) { g.fillStyle = pulse.c + "55"; rr(px(B.LANES[i] - 0.55), py(B.MID), sx * 1.1, py(B.H / 2 - 1.8), sx * 0.5); g.fill(); }
    if (s === "hold") { g.strokeStyle = "#7ec8e3"; g.setLineDash([6, 6]); g.lineWidth = 3; g.beginPath(); g.moveTo(px(B.LANES[i] - 0.7), py(B.MID + 1.2)); g.lineTo(px(B.LANES[i] + 0.7), py(B.MID + 1.2)); g.stroke(); g.setLineDash([]); }
  }
  // river + bridges
  g.fillStyle = "#3b8fd6"; g.fillRect(0, py(B.MID - 0.4), W, py(0.8));
  g.fillStyle = "rgba(255,255,255,0.25)"; g.fillRect(0, py(B.MID - 0.4), W, 3);
  for (const lx of B.LANES) { g.fillStyle = "#a07a4a"; rr(px(lx - 0.7), py(B.MID - 0.55), sx * 1.4, py(1.1), 6); g.fill(); g.strokeStyle = "#6b4b25"; g.lineWidth = 2; g.stroke(); }
  // deploy zone hint
  if (mode === "deploy") { g.fillStyle = "rgba(62,230,255,0.13)"; g.fillRect(0, py(B.MID + 0.5), W, py(B.H / 2 - 0.8)); g.strokeStyle = "#3ee6ff"; g.setLineDash([10, 8]); g.lineWidth = 2; g.strokeRect(2, py(B.MID + 0.5), W - 4, py(B.H / 2 - 0.8)); g.setLineDash([]); }
  if (mode === "strike") { g.fillStyle = "rgba(255,120,40,0.08)"; g.fillRect(0, 0, W, H); }
  // ore fields
  for (const [ox, oy] of [[0.7, B.H - 1.3], [8.3, B.H - 1.3], [0.7, 1.3], [8.3, 1.3]]) {
    for (let k = 0; k < 5; k++) { g.fillStyle = k % 2 ? "#f0c040" : "#ffd96a"; g.beginPath(); g.arc(px(ox + Math.cos(k * 1.3) * 0.35), py(oy + Math.sin(k * 2.1) * 0.35), sx * 0.16, 0, 7); g.fill(); }
  }
}
function drawBase(o) {
  const s = battle.sides[o], hq = B.HQ[o], c = COL[o];
  const flash = fx.find((f) => f.k === "hqFlash" && f.o === o);
  // side buildings
  const by = o === 0 ? B.H - 1.0 : 1.0;
  const blds = [["barracks", 2.6, "🏠"], ["factory", 6.4, "🏭"], ["techlab", 7.6, "🔬"]];
  for (const [k, bx, ic] of blds) {
    if (!s.built[k]) continue;
    g.fillStyle = c.dark; rr(px(bx - 0.5), py(by - 0.45), sx, py(0.9), 8); g.fill();
    g.strokeStyle = c.main; g.lineWidth = 2; g.stroke();
    g.font = `${Math.round(sx * 0.55)}px system-ui`; g.textAlign = "center"; g.textBaseline = "middle"; g.fillText(ic, px(bx), py(by));
  }
  // HQ
  const w = sx * 1.9, h = py(1.5);
  g.fillStyle = "rgba(0,0,0,0.3)"; rr(px(hq.x) - w / 2 + 4, py(hq.y) - h / 2 + 6, w, h, 12); g.fill();
  g.fillStyle = flash ? "#fff" : c.dark; rr(px(hq.x) - w / 2, py(hq.y) - h / 2, w, h, 12); g.fill();
  g.fillStyle = flash ? "#fff" : c.main; rr(px(hq.x) - w / 2 + 5, py(hq.y) - h / 2 + 5, w - 10, h * 0.45, 8); g.fill();
  g.strokeStyle = "#0b1220"; g.lineWidth = 3; rr(px(hq.x) - w / 2, py(hq.y) - h / 2, w, h, 12); g.stroke();
  g.font = `${Math.round(sx * 0.8)}px system-ui`; g.fillText(o === 0 ? "🏰" : "🏯", px(hq.x), py(hq.y) + 2);
}
function drawHarvesters(now) {
  for (const o of [0, 1]) {
    const n = battle.sides[o].harvesters, hq = B.HQ[o];
    for (let i = 0; i < n; i++) {
      const ore = i % 2 ? 8.3 : 0.7, ph = (Math.sin(now / 1400 + i * 2.1) + 1) / 2;
      const x = hq.x + (ore - hq.x) * ph * 0.92, y = hq.y + (o === 0 ? 0.1 : -0.1) * i;
      g.fillStyle = COL[o].dark; rr(px(x) - sx * 0.28, py(y) - sy * 0.18, sx * 0.56, sy * 0.36, 4); g.fill();
      g.fillStyle = "#f0c040"; g.fillRect(px(x) - sx * 0.15, py(y) - sy * 0.1, sx * 0.3, sy * 0.2 * ph);
    }
  }
}
const SHAPE = { infantry: 0.2, rocket: 0.2, tank: 0.36, artillery: 0.32 };
function drawUnits(now) {
  const us = [...battle.units].sort((a, b) => a.y - b.y);
  for (const u of us) {
    const c = COL[u.owner], r = sx * SHAPE[u.type], x = px(u.x), y = py(u.y) + Math.sin(now / 120 + u.id) * 1.2;
    g.fillStyle = "rgba(0,0,0,0.28)"; g.beginPath(); g.ellipse(x, y + r * 0.8, r, r * 0.4, 0, 0, 7); g.fill();
    g.fillStyle = u.flash > 0 ? "#ffffff" : c.main; g.strokeStyle = "#0b1220"; g.lineWidth = 2.5;
    if (u.type === "tank" || u.type === "artillery") { rr(x - r, y - r * 0.75, r * 2, r * 1.5, r * 0.35); g.fill(); g.stroke(); g.fillStyle = u.flash > 0 ? "#fff" : c.dark; g.beginPath(); g.arc(x, y, r * 0.5, 0, 7); g.fill(); g.strokeStyle = "#0b1220"; g.lineWidth = 4; g.beginPath(); g.moveTo(x, y); g.lineTo(x, y + (u.owner === 0 ? -1 : 1) * r * (u.type === "artillery" ? 1.6 : 1.2)); g.stroke(); }
    else { g.beginPath(); g.arc(x, y, r, 0, 7); g.fill(); g.stroke(); if (u.type === "rocket") { g.fillStyle = "#ffd96a"; g.fillRect(x + r * 0.3, y - r * 1.1, r * 0.5, r * 1.2); } }
    if (u.hp < u.max) {
      const bw = Math.max(sx * 0.6, r * 2);
      g.fillStyle = "#0b1220"; g.fillRect(x - bw / 2 - 1, y - r - 9, bw + 2, 6);
      g.fillStyle = u.owner === 0 ? "#3ddc84" : "#ff4a3d"; g.fillRect(x - bw / 2, y - r - 8, bw * (u.hp / u.max), 4);
    }
  }
}
function drawFx(dt) {
  for (const f of fx) {
    f.t -= dt;
    if (f.k === "tracer") {
      const k = Math.min(1, Math.max(0, 1 - f.t / f.max));
      if (f.type === "artillery") { const mx = f.x + (f.tx - f.x) * k, my = f.y + (f.ty - f.y) * k - Math.sin(k * Math.PI) * 1.5; g.fillStyle = "#222"; g.beginPath(); g.arc(px(mx), py(my), 4, 0, 7); g.fill(); }
      else { g.strokeStyle = f.o === 0 ? "#bfe6ff" : "#ffd0a0"; g.lineWidth = f.type === "tank" || f.type === "hq" ? 3 : 1.5; g.beginPath(); g.moveTo(px(f.x), py(f.y)); g.lineTo(px(f.tx), py(f.ty)); g.stroke(); }
    } else if (f.k === "boom" || f.k === "ring") {
      const k = Math.min(1, Math.max(0, 1 - f.t / 0.5)); g.strokeStyle = f.c; g.globalAlpha = Math.max(0, 1 - k); g.lineWidth = 4; g.beginPath(); g.arc(px(f.x), py(f.y), sx * (0.2 + k * 0.7), 0, 7); g.stroke();
      if (f.k === "boom") { g.fillStyle = "#ffd96a"; g.beginPath(); g.arc(px(f.x), py(f.y), sx * 0.35 * (1 - k), 0, 7); g.fill(); }
      g.globalAlpha = 1;
    } else if (f.k === "target") {
      g.strokeStyle = f.o === 0 ? "#ffa12e" : "#ff4a3d"; g.lineWidth = 3; g.setLineDash([8, 6]);
      g.beginPath(); g.ellipse(px(f.x), py(f.y), px(B.STRIKE.radius), py(B.STRIKE.radius), 0, 0, 7); g.stroke(); g.setLineDash([]);
    } else if (f.k === "blast") {
      const k = Math.min(1, Math.max(0, 1 - f.t / 0.7)); g.globalAlpha = Math.max(0, 1 - k);
      const gr = g.createRadialGradient(px(f.x), py(f.y), 0, px(f.x), py(f.y), px(B.STRIKE.radius) * (0.6 + k));
      gr.addColorStop(0, "#fff6c0"); gr.addColorStop(0.4, "#ff9a2e"); gr.addColorStop(1, "rgba(255,60,20,0)");
      g.fillStyle = gr; g.beginPath(); g.arc(px(f.x), py(f.y), px(B.STRIKE.radius) * (0.6 + k), 0, 7); g.fill(); g.globalAlpha = 1;
    }
  }
  fx = fx.filter((f) => f.t > 0);
}
function draw(now, dt) {
  g.setTransform(dpr, 0, 0, dpr, 0, 0);
  drawField(); drawBase(1); drawBase(0); drawHarvesters(now); drawUnits(now); drawFx(dt);
  if (dragging?.moved && dragging.at) { g.globalAlpha = 0.7; g.font = `${Math.round(sx * 0.9)}px system-ui`; g.textAlign = "center"; g.fillText(B.UNITS[dragging.type].icon, px(dragging.at.x), py(dragging.at.y)); g.globalAlpha = 1; }
}

// ---------- loop ----------
let acc = 0, hudT = 0;
function frame(now) {
  const dt = Math.min(0.1, (now - (last || now)) / 1000); last = now;
  if (!paused && battle.winner == null) {
    acc += dt;
    while (acc >= B.DT) { B.aiStep(battle, ai); B.step(battle); acc -= B.DT; }
    handleEvents();
  }
  hudT -= dt; if (hudT <= 0) { syncHud(); hudT = 0.1; }
  requestAnimationFrame(frame);
  try { draw(now, paused ? 0 : dt); } catch (err) { console.error(err); fx = []; }
}

addEventListener("resize", resize);
bindBounce();
newMatch(); resize(); tutorial();
requestAnimationFrame(frame);
// Test/screenshot hook (read + drive only through the public sim API).
window.__auto = { get battle() { return battle; }, B, newMatch, setPaused: (p) => (paused = p), endScreen, syncHud, renderBase };
